import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SiteCtx = createContext({ settings: {}, reload: () => {} });

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({});
  const reload = useCallback(async () => {
    try {
      const r = await api.get("/settings");
      setSettings(r.data);
    } catch (e) {
      setSettings({});
    }
  }, []);
  useEffect(() => {
    reload();
  }, [reload]);
  return <SiteCtx.Provider value={{ settings, reload }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
